import { format, parseISO } from 'date-fns'
import { ru } from 'date-fns/locale'

/**
 * Форматирует дату в красивом виде для отображения
 * @param dateString - строка с датой (ISO формат)
 * @returns отформатированная дата
 */
export const formatDate = (dateString: string): string => {
    try {
        const date = parseISO(dateString)
        return format(date, 'dd.MM.yyyy HH:mm', { locale: ru })
    } catch (error) {
        console.error('Ошибка форматирования даты:', error)
        return dateString
    }
}

/**
 * Форматирует дату в кратком виде (только дата)
 * @param dateString - строка с датой (ISO формат)
 * @returns отформатированная дата
 */
export const formatDateShort = (dateString: string): string => {
    try {
        const date = parseISO(dateString)
        return format(date, 'dd.MM.yyyy', { locale: ru })
    } catch (error) {
        console.error('Ошибка форматирования даты:', error)
        return dateString
    }
}

/**
 * Форматирует дату с относительным временем (например, "2 часа назад")
 * @param dateString - строка с датой (ISO формат)
 * @returns отформатированная дата
 */
export const formatRelativeTime = (dateString: string): string => {
    try {
        const date = parseISO(dateString)
        const now = new Date()
        const diffInHours = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60))

        if (diffInHours < 1) {
            return 'только что'
        } else if (diffInHours < 24) {
            return `${diffInHours} ч. назад`
        } else {
            const diffInDays = Math.floor(diffInHours / 24)
            return `${diffInDays} д. назад`
        }
    } catch (error) {
        console.error('Ошибка форматирования даты:', error)
        return dateString
    }
}
